<div class="form-container" fxLayout="column">
  <div fxFlex="100%" fxLayout="row" fxLayoutAlign="space-between center">
    <h3 fxLayout="row" fxLayoutAlign="start center">
      Change Profile Status in Org into
      {{ workspace.workspaceName }} (workspace)
    </h3>
  </div>
  <div fxLayout="column" class="status-container">
    <mat-radio-group [value]="personStatus">
      <mat-nav-list>
        <mat-list-item
          (click)="setPotential()"
          [disabled]="workspace?.numOfPersonWorkspaceTeams > 0"
        >
          <div fxLayout="column">
            <mat-radio-button
              color="primary"
              value="Potential"
              class="status-header"
              [disabled]="workspace?.numOfPersonWorkspaceTeams > 0"
            >
              Potential
              @if (workspace?.numOfPersonWorkspaceTeams > 0) {
                <div class="status-warning">
                  <mat-icon>warning</mat-icon
                  ><span>This person is currently on an active team.</span>
                </div>
              }
            </mat-radio-button>
            <p class="status-text">
              Potential people cannot be added to a team. Use this status when
              you are still evaluating or vetting someone to be added to your
              active pool.
            </p>
          </div>
        </mat-list-item>
        <mat-list-item (click)="setActive()">
          <div fxLayout="column">
            <mat-radio-button
              color="primary"
              value="Active"
              class="status-header"
              >Active</mat-radio-button
            >
            <p class="status-text">
              Active people can be added to teams and will appear when searching
              for Active People.
            </p>
          </div>
        </mat-list-item>
        <mat-list-item (click)="setArchived()">
          <div fxLayout="column">
            <mat-radio-button
              color="primary"
              value="Archived"
              class="status-header"
              >Archived</mat-radio-button
            >
            <p class="status-text">
              Archive someone when you do not want them to appear in active
              searches or add them to teams in the future. Archived people will
              still appear on teams that you have already created.
            </p>
          </div>
        </mat-list-item>
      </mat-nav-list>
    </mat-radio-group>
    <div class="button-container" mat-dialog-actions>
      <button
        mat-flat-button
        color="primary"
        [disabled]="!statusChanged()"
        (click)="save()"
      >
        Update
      </button>
      <button type="button" mat-stroked-button (click)="close()">Cancel</button>
    </div>
  </div>
</div>
